module.exports = __webpack_public_path__ + "img/921_page_rebuild4.8f3e5f57.png";